module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_desktop3-dd6c83ee2fabf29daee1fa958630e574.jpg";